import axios from "axios";

const drawMore = () => {
  const offset = document.querySelectorAll(".pager_item").length;

  const displayTotal = document.getElementById("display_total");
  if (displayTotal && offset < parseInt(displayTotal.textContent, 10)) {
    document.getElementById("more_click").style.display = "block";
  } else {
    document.getElementById("more_result").style.display = "none";
  }
};

/**
 * 「次の◯件を読み込む」を押下時の読み込み処理
 */
const initMoreClickButton = () => {
  const moreClickButton = document.getElementById("more_click");

  moreClickButton?.addEventListener("click", (e) => {
    e.preventDefault();
    const button = e.currentTarget;

    const pager = document.querySelector("[data-pager]");
    if (
      !pager ||
      document.querySelectorAll("[data-pager]").length !== 1 ||
      button.disabled
    ) {
      return false;
    }
    button.disabled = true;

    // パラメータ設定
    const offset = document.querySelectorAll(".pager_item").length;
    document.querySelector("#search_from input[name=offset]").value = offset;

    const searchForm = document.getElementById("search_from");
    const actionUrl = searchForm.getAttribute("action");

    axios
      .get(actionUrl, {
        params: new URLSearchParams(new FormData(searchForm)),
      })
      .then((response) => {
        pager.insertAdjacentHTML("beforeend", response.data);
        drawMore(pager);
        button.disabled = false;
      });

    return false;
  });
};

export default initMoreClickButton;
